/**
 * useReasonTypeEntryScreen.js
 * ---------------------------
 * Hook for Inquiry Reason create/edit form screen using shared useMasterEntry.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as reasonTypeApi from '../api/reasonTypeApi';

export function useReasonTypeEntryScreen() {
  return useMasterEntry({
    entityName: 'Inquiry Reason',
    apiClient: reasonTypeApi.reasonTypeClient,
    fetchDetail: reasonTypeApi.getReasonTypeDetail,
    createItem: reasonTypeApi.createReasonType,
    updateItem: reasonTypeApi.updateReasonType,
    initialForm: {
      name: '',
      short_name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Inquiry Reason Name is required.';
      }
      return null;
    },
    listPath: '/masters/reason-type/list',
    transformPayload: (form, operationalStatus) => ({
      name: form.name.trim(),
      short_name: form.short_name ? form.short_name.trim() : null,
      status: operationalStatus === 'active' ? 'Active' : 'Archived',
    }),
    transformDetail: (detail) => ({
      form: {
        name: detail.name || '',
        short_name: detail.short_name || '',
      },
      operationalStatus: detail.status === 'Active' ? 'active' : 'inactive',
    }),
  });
}
